<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts" setup></script>
<style>
#app {
  text-align: center;
  height: 100dvh;
}
</style>
